import politicaPrivacidadeMarkdown from "../../politicaprivacidade.md?raw";
import politicaCancelamentoMarkdown from "../../politicacancelamento.md?raw";
import termoConsentimentoMarkdown from "../../termoconsentimento.md?raw";
import termosDeUsoMarkdown from "../../termosdeuso.md?raw";

type LegalDocument = {
  title: string;
  content: string;
};

const parseLegalDocument = (markdown: string): LegalDocument => {
  const normalized = markdown.replace(/^\uFEFF/, "").replace(/\r\n/g, "\n").trim();
  const [firstLine, ...remainingLines] = normalized.split("\n");

  return {
    title: firstLine.trim(),
    content: remainingLines.join("\n").trim(),
  };
};

export const legalContent = {
  termosDeUso: parseLegalDocument(termosDeUsoMarkdown),
  termoConsentimento: parseLegalDocument(termoConsentimentoMarkdown),
  politicaCancelamento: parseLegalDocument(politicaCancelamentoMarkdown),
  politicaPrivacidade: parseLegalDocument(politicaPrivacidadeMarkdown),
};
